<fc-search-many-input
  [label]="'MAINTENANCE_TYPES.LABEL' | translate"
  [control]="control"
  [search]="search"
  [displayWith]="displayWith"
  [requiredMark]="requiredMark"
></fc-search-many-input>
